<template>
    <div class="clinictreat_body_main">
        <div class="body_bd_main flex_t_col">
            <div class="performance_top">
                <el-form @submit.prevent="queryData()">
                <el-row :gutter="20">
                    <el-radio-group class="search_width mrr20" v-model="actDate" @change="chooseDate()">
                        <el-radio-button label="0">近7天</el-radio-button>
                        <el-radio-button label="1">今日</el-radio-button>
                        <el-radio-button label="2">昨天</el-radio-button>
                        <el-radio-button label="3">近30天</el-radio-button>
                    </el-radio-group>
                    <div class="search_width mrr20">
                        <el-date-picker
                            v-model="range"
                            type="daterange"
                            range-separator="~"
                            start-placeholder="开始时间"
                            end-placeholder="结束时间"
                            prefix-icon="Calendar"
                            format="YYYY-MM-DD"
                            value-format="YYYY-MM-DD"
                        />
                    </div>
                    <div class="search_width">
                        <el-button type="primary" native-type="submit">查询</el-button>
                        <el-button type="info" @click="resetQuery()">重置</el-button>
                    </div>
                </el-row>
                </el-form>

                <el-row :gutter="20">
                    <el-col class="performance_top_licon" :span="4">
                        <div class="performance_top_icon">
                            <el-image fit="fill" :src="performanceIcon1"></el-image>
                        </div>
                        <div class="performance_top_info flex_c_col">
                            <div class="top_info_title flex_c_left">总额度（元）</div>
                            <div class="top_info_number flex_c_left">{{total_amount}}</div>
                        </div>
                    </el-col>
                    <el-col class="performance_top_licon" :span="1"></el-col>
                    <el-col class="performance_top_licon" :span="4">
                        <div class="performance_top_icon">
                            <el-image fit="fill" :src="performanceIcon2"></el-image>
                        </div>
                        <div class="performance_top_info flex_c_col">
                            <div class="top_info_title flex_c_left">诊费（元）</div>
                            <div class="top_info_number flex_c_left">{{doc_amount}}</div>
                        </div>
                    </el-col>
                    <el-col class="performance_top_licon" :span="1"></el-col>
                    <el-col class="performance_top_licon" :span="4">
                        <div class="performance_top_icon">
                            <el-image fit="fill" :src="performanceIcon3"></el-image>
                        </div>
                        <div class="performance_top_info flex_c_col">
                            <div class="top_info_title flex_c_left">药费（元）</div>
                            <div class="top_info_number flex_c_left">{{medical_amount}}</div>
                        </div>
                    </el-col>
                    <el-col class="performance_top_licon" :span="1"></el-col>
                    <el-col class="performance_top_licon" :span="4">
                        <div class="performance_top_icon">
                            <el-image fit="fill" :src="performanceIcon4"></el-image>
                        </div>
                        <div class="performance_top_info flex_c_col">
                            <div class="top_info_title flex_c_left">调理费用（元）</div>
                            <div class="top_info_number flex_c_left">{{adjust_amount}}</div>
                        </div>
                    </el-col>
                    <el-col class="performance_top_licon" :span="1"></el-col>
                    <el-col class="performance_top_licon" :span="4">
                        <div class="performance_top_icon">
                            <el-image fit="fill" :src="performanceIcon5"></el-image>
                        </div>
                        <div class="performance_top_info flex_c_col">
                            <div class="top_info_title flex_c_left">优惠金额（元）</div>
                            <div class="top_info_number flex_c_left">{{discount_amount}}</div>
                        </div>
                    </el-col>
                </el-row>
            </div>

            <div class="performance_bottom flex_t_between">
                <div class="charts-box">
                    <div class="charts_title flex_c_left">{{columnTitle}}</div>
                    <div class="charts_con flex_c" ref="columnChartCon">
                        <canvas id="columnChartContainer" :width="columnWidth" :height="columnHeight" class="charts_canvas" @click="tap"/>
                    </div>
                </div>
                <div class="charts-box2">
                    <div class="charts_title flex_c_left">费用占比</div>
                    <div class="charts_con flex_c" ref="ringChartCon">
                        <canvas id="ringChartContainer" :width="ringHeight" :height="ringHeight" class="charts_canvas" @click="tap"/>
                    </div>
                </div>
            </div>

        </div>
    </div>

</template>

<script>
import performance from '@/assets/scripts/performance/index'

export default performance;
</script>

<style scoped>
@import "@/assets/styles/style.scss";
</style>